import { STATUS, ARTIST_STATUS_OVERRIDE } from "@/constants/catalog";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/i18n";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, className, testId = "release-row-status-badge" }) => {
  const { user } = useAuth();
  const s = (user?.role === "artist" && ARTIST_STATUS_OVERRIDE[status]) || STATUS[status] || STATUS.draft;
  const live = ["queued", "running", "uploading", "waiting_2fa"].includes(status);
  return (
    <span data-testid={testId} data-status={status}
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap", s.cls, className)}>
      <span className={cn("h-1.5 w-1.5 rounded-full bg-current", live && "pulse-dot")} />
      {t(s.label)}
    </span>
  );
};

export const CodeBadge = ({ code, kind = "upc", placeholder = "sin asignar" }) => {
  if (!code) return <span data-testid={`${kind}-code-badge`} className="text-xs text-muted-foreground italic">{t(placeholder)}</span>;
  const copy = (e) => { e.stopPropagation(); navigator.clipboard?.writeText(code); import("sonner").then(({ toast }) => toast.success(t(`${kind.toUpperCase()} copiado`))); };
  return (
    <button type="button" onClick={copy} data-testid={`${kind}-code-badge`} title={t("Copiar")} className="code-badge hover:brightness-125 transition">
      {code}
    </button>
  );
};

export const PageHeader = ({ eyebrow, title, description, children, testId }) => (
  <div className="flex flex-wrap items-end justify-between gap-4" data-testid={testId}>
    <div className="min-w-0">
      {eyebrow && <p className="eyebrow flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-primary" />{t(eyebrow)}</p>}
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight truncate mt-1">{t(title)}</h1>
      {description && <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{t(description)}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);
